import React from 'react';
import Header from '../../components/Justificantes/Header/Header';
import JustificantesComponent from '../../components/Justificantes/Justificantes/Justificantes';

const Justificantes = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <Header />
        </div>
        <div>
            <JustificantesComponent />
        </div>
      </div>
    );
  };
  
export default Justificantes;

